/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import AllergyFilterPopup from "./Popup/AllergyFilterPopup";
import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import SaveAllergyPopup from "components/Common/Popup/SaveAllergyPopup";

const AllergiesSection = ({ patientObj = null }) => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [allergyList, setAllergyList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedAllergyIds, setSelectedAllergyIds] = useState([]);
  const [selectedAllergyId, setSelectedAllergyId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  // get all allergies
  const getAllAllergiesByPatientId = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_ALLERGY +
        `?token=${token}&members=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in allergy list------->", requestUrl);

      const response = await getData(requestUrl);
      setIsLoading(false);
      if (response.status) {
        setAllergyList(response.data);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setAllergyList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveAllergyOffCanvas"
            aria-controls="saveAllergyOffCanvas"
            onClick={() => {
              setSelectedAllergyId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Allergen",
        accessorKey: "allergen",
        size: 200,
        Cell: ({ row }) => (
          <span>
            {row.original.allergen ? (
              row.original.allergen
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Allergy Type",
        accessorKey: "allergytype",
        size: 180,
        Cell: ({ row }) => (
          <span>
            {row.original.allergytype ? (
              row.original.allergytype
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Reported Date",
        accessorKey: "reportedondate",
        size: 160,
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.reportedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Resolved Date",
        accessorKey: "resolvedondate",
        size: 160,
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.resolvedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Severity",
        accessorKey: "severity",
        size: 120,
        Cell: ({ row }) => (
          <span>
            {row.original.severity ? (
              row.original.severity
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Reaction",
        accessorKey: "reaction",
        size: 120,
        Cell: ({ row }) => (
          <span>
            {row.original.reaction ? (
              row.original.reaction
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Current Status",
        accessorKey: "currentstatus",
        Cell: ({ row }) => (
          <span>
            {typeof row.original.currentstatus === "string" &&
            row.original.currentstatus !== "" ? (
              row.original.currentstatus
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllAllergiesByPatientId();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllAllergiesByPatientId();
      setReloadData(false);
    }
  }, [reloadData]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <h3 className="mb-3">Allergies</h3>
          </div>

          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>

            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#allergyFilterOffCanvas"
              aria-controls="allergyFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveAllergyOffCanvas"
              aria-controls="saveAllergyOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={allergyList}
            enableGrouping
            enableRowSelection={false}
            getRowId={(row) => row._id}
            state={{ columnOrder }}
            initialState={{ columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* popup and modals */}
      <SaveAllergyPopup
        selectedAllergyId={selectedAllergyId}
        setSelectedAllergyId={setSelectedAllergyId}
        afterActionClose={afterActionClose}
        patientObj={patientObj}
      />

      {/* ------- filter popup ------- */}
      <AllergyFilterPopup
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        moduleSlug="allergypatient"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columnOrder={columnOrder}
      />
    </div>
  );
};

export default AllergiesSection;
